import { render, staticRenderFns } from "./StatsPhoenixDevice.vue?vue&type=template&id=2a1688bc&"
import script from "./StatsPhoenixDevice.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixDevice.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixDevice.vue?vue&type=style&index=0&id=2a1688bc&prod&lang=scss&"
import style1 from "./StatsPhoenixDevice.vue?vue&type=style&index=1&id=2a1688bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports